/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

// window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app',
// });

// window.Alpine = Alpine
 
// Alpine.start()

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

import Swiper from "swiper/bundle";
import "swiper/css/bundle";

const swiper = new Swiper(".home_swiper", {
    effect: "fade",
    fadeEffect: {
        crossFade: true
    },
    speed: 1500,
    autoplay: {
        delay: 4000
    }
    // pagination: {
    //     el: '.pagination1',
    //     clickable: true,
    // }
});

const swiper2 = new Swiper(".block_swiper", {
    spaceBetween: 15,
    slidesPerView: 1.5,
    breakpoints:{
        780:{
            slidesPerView: 3
        },
        960:{
            slidesPerView: 4
        }
    },
    speed: 1500,
    pagination: {
        el: '.block_pagination',
        type: 'fraction',
        // formatFractionCurrent: function(number){
        //     return('0' + number).slice(-2); 
        // },
        // formatFractionTotal: function(number){
        //     return('0' + number).slice(-2);
        // },
        // renderFraction: function (currentClass, totalClass) {
        //     return `<div class="fraction_container">
        //             <span class="${currentClass} firstNum"></span> 
        //             <span class="line">/</span>
        //             <span class="${totalClass} total"></span>
        //             </div>
        //             `
        // },
    },
    navigation: {
        nextEl: ".swiper-next",
        prevEl: ".swiper-prev",
    },
});


// const arr = document.querySelectorAll('.gallery');
// // const galleryArr = Array.from(arr);
// console.log(arr);

// arr.forEach( function(element, index) {
//     element.id = "gallery"+ index ;
//     let item = element.id;
//     // console.log(item);
//     // console.log(typeof(item));
//     // let idItem = '#'+element.id;
//     // console.log(idItem);
//     // Fancybox.bind('idItem a',{
//     //     groupAll: true,
//     //     on : {
        
//     //     }
//     // })
// });












